import { Alert } from "antd";
import { FC } from "react";

interface ErrorViewProps {
  error: Error;

  eventId?: string;
  componentStack?: string;
  resetError?: () => void;
}

export const InlineErrorView: FC<ErrorViewProps> = ({ error }) => {
  return (
    <Alert
      style={{ width: "100%" }}
      message="Something went wrong."
      type="error"
      showIcon
    />
  );
};
